module.exports = __webpack_public_path__ + "media/images/intro-323b882d2da7fc07e485e72546b87461.jpg";